<template>
  <div class="substep-approve-time-off-requests">
    <div class="substep-header">
      <h3 data-testId="step-title">Approve a time off request</h3>
      <p>View all your team's details for the time-off request, review it, and approve it.</p>
    </div>

    <div
      v-if="isTimeOffApproved"
      class="card-image"
    >
      <img
        rel="preload"
        :src="GETTING_STARTED['timesheet_approved'].src"
        :alt="GETTING_STARTED['timesheet_approved'].alt"
      />
      <p>Congrats! You successfully approved this time off request</p>
    </div>
    <div v-else>
      <AppTable
        :table-data="timeOffRequests"
        class="time-off-requests-table"
      >
        <AppTableColumn
          v-slot="{ row }"
          header-classes="col-member"
          cell-classes="col-member"
          header="Member"
          name="member"
        >
          <div class="member">
            <AppAvatar
              :avatar="row.avatar"
              size="speck"
            />

            <span
              :title="row.name"
              class="line-clamp-2 w-fit"
              v-text="row.name"
            ></span>
          </div>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          header-classes="col-policy"
          cell-classes="col-policy"
          header="Policy"
        >
          <span>{{ row.policy }}</span>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          header-classes="col-reason"
          cell-classes="col-reason"
          header="Reason"
        >
          <span>{{ row.reason }}</span>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          header-classes="col-start"
          cell-classes="col-start"
          header="Start"
        >
          <span>{{ row.start_date }}</span>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          header-classes="col-end"
          cell-classes="col-end"
          header="End"
        >
          <span>{{ row.end_date }}</span>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          header-classes="col-hours"
          cell-classes="col-hours"
          header="Hours requested"
        >
          <span>{{ row.hours }}</span>
        </AppTableColumn>

        <AppTableColumn
          header-classes="text-align-right"
          cell-classes="text-align-right"
          header=""
          name="action"
        >
          <AppButton
            class="approve-time-off-request"
            aria-label="Approve time off request"
            @click="approveTimeOffRequest()"
          >
            Approve
          </AppButton>
        </AppTableColumn>
      </AppTable>
    </div>
  </div>
</template>

<script>
import GettingStartedMixin from '~/mixins/GettingStarted/GettingStartedMixin';
import AppTable from '~/components/AppTable.vue';
import { GETTING_STARTED } from '~/app_constants';

export default {
  name: 'ApproveATimeOffRequest',
  components: {
    AppTable,
  },
  mixins: [GettingStartedMixin],
  props: {
    timeOffRequests: {
      type: Array,
      default: () => Object.freeze([]),
      validator: (time_off_requests) => {
        return time_off_requests.every((time_off_request) => {
          const { id, name, avatar, policy, reason, start_date, end_date, hours } = time_off_request;

          return (
            typeof id === 'number' &&
            typeof name === 'string' &&
            typeof avatar === 'string' &&
            typeof policy === 'string' &&
            typeof reason === 'string' &&
            typeof start_date === 'string' &&
            typeof end_date === 'string' &&
            typeof hours === 'string'
          );
        });
      },
    },
  },
  data: () => ({
    isTimeOffApproved: false,
    GETTING_STARTED,
  }),
  methods: {
    approveTimeOffRequest() {
      this.isTimeOffApproved = true;
      this.$emit('completeSubstep');
    },
  },
};
</script>
